import { observer } from "mobx-react";
import * as React from "react";
import { applicationStore } from "../../../stores/ApplicationStore";
import { THEME } from "../../../theme/ThemeStore";
import { ApplicationValues } from "../../../types/models";
import { pushRoute } from "../../app/router/history";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { TopImage } from "../../ui/TopImage";
import { MotivationForm } from "../MotivationForm";
import { ApplicationRoutes } from "../router/ApplicationRoutes";

export const MotivationSite = observer(() => {
    const handleSubmit = (application: ApplicationValues) => {
        applicationStore.currentApplication = application;
        applicationStore.isStepFinished["motivation"] = true;
        pushRoute(ApplicationRoutes.VERIFICATION);
    };

    const handleBack = () => {
        pushRoute(ApplicationRoutes.DATA_UPLOAD);
    };

    React.useEffect(() => {
        if (!applicationStore.isStepFinished["dataUpload"]) {
            pushRoute(ApplicationRoutes.PERSONAL_DATA);
        }
    }, []);

    return (
        <>
            <TopImage imageUrl={THEME.Images.headerImage04} />
            <ContentWrapper>
                <MotivationForm onSubmit={handleSubmit} onBack={handleBack} />
            </ContentWrapper>
        </>
    );
});
